import { apiClient } from '../../services/api'
import { trackPromise } from 'react-promise-tracker'
import { UPDATE_SELECTED_ACADEMIC_YEAR, UPDATE_SELECTED_SEMESTER, UPDATE_SEMESTER, UPDATE_ACDEMIC_YEAR } from '../actionTypes'

export const login = auth => ({
  type: 'AUTH_LOGIN',
  payload: auth,
})
